import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS } from '../../utils/handler';
import { CALENDAR_URLS } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET } = HTTP_METHODS;
const { GET_CALENDAR_EVENTS_DATA } = CALENDAR_URLS;

export const calendarApi = createApi({
  reducerPath: 'calendarApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getCalendarEventsData: builder.query({
      query: () => ({ url: `${GET_CALENDAR_EVENTS_DATA}`, method: GET })
    })
  })
});

export const { useGetCalendarEventsDataQuery } = calendarApi;
